export default __webpack_public_path__ + "static/media/canada.a1f2d015.svg";